import {registerRoute as workbox_routing_registerRoute} from '/home/runner/work/bmpi.dev/bmpi.dev/node_modules/workbox-routing/registerRoute.mjs';
import {ExpirationPlugin as workbox_expiration_ExpirationPlugin} from '/home/runner/work/bmpi.dev/bmpi.dev/node_modules/workbox-expiration/ExpirationPlugin.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/home/runner/work/bmpi.dev/bmpi.dev/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/home/runner/work/bmpi.dev/bmpi.dev/node_modules/workbox-strategies/CacheFirst.mjs';
import {setCacheNameDetails as workbox_core_setCacheNameDetails} from '/home/runner/work/bmpi.dev/bmpi.dev/node_modules/workbox-core/setCacheNameDetails.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/home/runner/work/bmpi.dev/bmpi.dev/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/home/runner/work/bmpi.dev/bmpi.dev/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {initialize as workbox_google_analytics_initialize} from '/home/runner/work/bmpi.dev/bmpi.dev/node_modules/workbox-google-analytics/initialize.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */





workbox_core_setCacheNameDetails({prefix: "bmpi"});


self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/css/coder-dark.min.a2fdc25deb82b741f3a807e38508c2dea269fc900c2b37ee8af380d97ea4d7a8.css",
    "revision": "3c6e82be42e7c12e5f9644e2e70aa4f1"
  },
  {
    "url": "/css/coder.min.dc1c9d640646dcf8981767535bc5d3b6a5528cf152df9e1d019bf48a761725e7.css",
    "revision": "7bdcc99b11970fd2a3dbf5a2e6ad2dab"
  },
  {
    "url": "/css/en-fonts.css",
    "revision": "2f7e6a7361cb96c013f1d6efc6f10887"
  },
  {
    "url": "/css/main.css",
    "revision": "878348dee1e5a140e656684d0d416b79"
  },
  {
    "url": "/css/markmap-toolbar@0.15.4.css",
    "revision": "e0834c5427f070c928f9ac0aecfe80f2"
  },
  {
    "url": "/js/article-copy.js",
    "revision": "7ec0fcb8bd9f1c66344d271d7cbbce6a"
  },
  {
    "url": "/js/custom.js",
    "revision": "1a60097b3fc3e9cfce042b21bb3e1545"
  },
  {
    "url": "/js/flying-pages.min.js",
    "revision": "b59fc515e39445721deca27331d7af5e"
  },
  {
    "url": "/js/lazysizes.min.js",
    "revision": "0812d0f17b90a4aefd97bb91085ad252"
  },
  {
    "url": "/js/markmap-autoloader@0.15.4.js",
    "revision": "a6219425826589e37b20d2fdc3fca5f1"
  },
  {
    "url": "/js/markmap-lib@0.15.4.js",
    "revision": "31cf98d98b02d79eaa0657aaeb890ffc"
  },
  {
    "url": "/js/markmap-toolbar@0.15.4.js",
    "revision": "b995e21bd1fbc9b1dd3f71180c00c1e5"
  },
  {
    "url": "/js/markmap-view@0.15.4.js",
    "revision": "53d3160c2b066cee23b36fa599afb815"
  },
  {
    "url": "/js/rawdeflate.js",
    "revision": "56833d3e26e4a7df806880c4aedd949b"
  },
  {
    "url": "/resume/css/bootstrap.min.css",
    "revision": "8a7442ca6bedd62cec4881040b9a9e83"
  },
  {
    "url": "/resume/css/font-awesome.css",
    "revision": "1f9e9d1a5a1d347d945ef4b7727f2ea0"
  },
  {
    "url": "/resume/css/main.css",
    "revision": "e6a80022f9313b7d897d5674f4c0c03f"
  },
  {
    "url": "/resume/fonts/fontawesome-webfont.eot",
    "revision": "8b27bc96115c2d24350f0d09e6a9433f"
  },
  {
    "url": "/resume/fonts/fontawesome-webfont.ttf",
    "revision": "dcb26c7239d850266941e80370e207c1"
  },
  {
    "url": "/resume/fonts/fontawesome-webfont.woff",
    "revision": "3293616ec0c605c7c2db25829a0a509e"
  },
  {
    "url": "/resume/fonts/FontAwesome.otf",
    "revision": "3f3a623e88cb5c62eaa2367195e98b67"
  },
  {
    "url": "/resume/js/bootstrap.min.js",
    "revision": "ba847811448ef90d98d272aeccef2a95"
  },
  {
    "url": "/resume/js/html5shiv.js",
    "revision": "0ce8f355891c26c28f057e195e97dcd5"
  },
  {
    "url": "/resume/js/jquery.min.js",
    "revision": "8fc25e27d42774aeae6edbc0a18b72aa"
  },
  {
    "url": "/resume/js/respond.min.js",
    "revision": "afc1984a3d17110449dc90cf22de0c27"
  },
  {
    "url": "/resume/js/scripts.js",
    "revision": "fab46264d61b3c0b8c3c02cce4ebc215"
  },
  {
    "url": "/scss/tagcloud.css",
    "revision": "d3b3748df678d4e3d8d4b9eee04d5066"
  },
  {
    "url": "/webpushr-sw.js",
    "revision": "f6f7ff6d6b7b7b652cb92a25eb2cef5b"
  }
], {
  "ignoreURLParametersMatching": [/./]
});




workbox_routing_registerRoute(/(?:\/)$/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"html", plugins: [new workbox_expiration_ExpirationPlugin({ maxAgeSeconds: 604800 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:png|jpg|jpeg|gif|bmp|webp|svg|ico)$/, new workbox_strategies_CacheFirst({ "cacheName":"images", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 1000, maxAgeSeconds: 31536000 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:mp3|wav|m4a)$/, new workbox_strategies_CacheFirst({ "cacheName":"audio", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 1000, maxAgeSeconds: 31536000 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:m4v|mpg|avi)$/, new workbox_strategies_CacheFirst({ "cacheName":"videos", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 1000, maxAgeSeconds: 31536000 })] }), 'GET');


workbox_google_analytics_initialize({});

